import React, { useEffect } from "react";
import { FaUserCircle, FaBars , FaSun, FaMoon} from "react-icons/fa"; // Import FaBars
import useAuthStore from "@/store/useAuthStore";
import { useUserStore } from "@/store";
import { useLocation } from "react-router-dom";
import NotificationPopover from "@/pages/Notifications/Notification";
import { useTenantContext } from "@/components/Navbar/TenantContext";
import useSidebarStore from "@/store/useSidebarStore"; // Import useSidebarStore
import useThemeStore from "@/store/useThemeStore";

const Navbar: React.FC = () => {
  const { pageHeader, setPageHeader } = useUserStore();
  const { userName, role } = useAuthStore();
  const location = useLocation();
  const { tenantName } = useTenantContext();
  const { toggleSidebar } = useSidebarStore(); // Use the sidebar store
  const { theme, toggleTheme } = useThemeStore();

  useEffect(() => {
    if (!location.pathname) return;

    let header = "";
    switch (true) {
      case location.pathname.startsWith("/dashboard"):
        header =
          role === "ADMIN"
            ? "Admin Dashboard"
            : role === "SUPER_ADMIN"
              ? "Super Admin Dashboard"
              : role === "MANAGER"
                ? "Manager"
                : "Dashboard";
        break;
      case location.pathname.startsWith("/users"):
        header = "User Management";
        break;
      case location.pathname.startsWith("/notification"):
        header = "Notifications";
        break;
      case location.pathname.startsWith("/contact"):
        header = "Support";
        break;
      case location.pathname.startsWith("/subscription"):
        header = "Subscription Plan";
        break;
      case location.pathname.startsWith("/teams"):
        header = "Teams";
        break;
      case location.pathname.startsWith("/usage-tracker"):
        header = "Usage Tracker";
        break;
      case location.pathname.startsWith("/company-profile-info"):
        header = "My Organization";
        break;
      case location.pathname.startsWith("/company-profile-manual"):
        header = "My Organization";
        break;
      case location.pathname.startsWith("/company-profile"):
        header = "My Organization";
        break;
      case location.pathname.startsWith("/usage-logs"):
        header = "Usage Logs";
        break;
      case location.pathname.startsWith("/grant-credits"):
        header = "Grant Credits";
        break;
      case location.pathname.startsWith("/script"):
        header = "Scripts";
        break;
      case location.pathname.startsWith("/tenants"):
        header = "Organizations";
        break;
      case location.pathname.startsWith("/meeting-dashboard"):
        header = "Activity Dashboard";
        break;
      case location.pathname.startsWith("/meetings"):
        header = "Meetings";
        break;
      case location.pathname.startsWith("/meeting-detail"):
        header = "Meeting Details";
        break;
      default:
        header = "";
    }
    setPageHeader(header);
  }, [location.pathname, role, setPageHeader]);

  return (
    <div
      className="bg-navbar px-6 py-3 flex items-center justify-between shadow-sm transition-all duration-300 w-full"
    >
      <div className="relative w-auto max-w-full flex items-center">
        <button
          onClick={toggleSidebar}
          className="text-foreground text-xl md:hidden mr-4"
          aria-label="Toggle Sidebar"
        >
          <FaBars />
        </button>
        <div className="flex items-center space-x-4">
          <div className="w-1 h-8 bg-[#2E9E4F] rounded-full"></div>
          <div>
            <h1 className="text-2xl font-bold font-poppins text-foreground">
              {pageHeader}
            </h1>
            {tenantName && (
              <p className="text-xs text-muted mt-0.5">{tenantName}</p>
            )}
          </div>
        </div>
      </div>

      <div className="flex items-center gap-4 px-2 text-foreground">
        <button
          onClick={toggleTheme}
          aria-label="Toggle theme"
          className="text-xl text-foreground hover:opacity-80 transition-opacity p-2 rounded-full cursor-pointer"
        >
          {theme === "dark" ? <FaSun className="text-amber-400" /> : <FaMoon className="text-slate-700" />}
        </button>
        <NotificationPopover />
        <div className="leading-tight text-right hidden sm:block">
          <h1 className="text-foreground font-semibold text-sm">{userName}</h1>
          <div className="text-xs text-muted">
            Welcome {userName?.split(" ")[0]}
          </div>
        </div>
        <FaUserCircle className="text-2xl text-foreground opacity-80" />
      </div>
    </div>
  );
};

export default Navbar;
